import {
  Box,
  Button,
  Card,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  calendarEditIcon,
  closeIcon,
  courseListSecondaryIcon,
  editGreyIcon,
  editPurpleIcon,
  filterLightIcon,
  filterPrimaryIcon,
  listCheckIcon,
  noteIcon,
  personEditIcon,
} from "assets/images";
import AllocateSLPModal from "components/AllocateSLPModal";
import NoRecords from "components/NoRecords";
import SLPContactNoteModal from "components/SLPContactNoteModal";
import SLPParticipationModal from "components/SLPParticipationModal";
import CustomPagination from "components/customPagination";
import dayjs from "dayjs";
import { ExportToCsv } from "export-to-csv";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import {
  PLAUserListPayload,
  SLPRequestsPayload,
  SLPRequestsPDFPayload,
  SLPRequestsPDFSuccessPayload,
  SLPRequestsSuccessPayload,
  UpdateSLPContactNotePayload,
  UpdateSLPParticipationPayload,
} from "store/slpDashboard/type";
import {
  AllocatePLAPayload,
  DeferSLPPayload,
  IUpdateContactDateRequestPayload,
} from "store/studentProfileDetails/types";
import {
  CONTACT_NOTE_ADD_SUCCESS_MESSAGE,
  DUE_DATE_TO_SHOULD_GREATER_MSG,
  NO_RECORD_FOUND,
  SLP_PARTICIPATION_UPDATE_MSG,
} from "utils/constants/Messages";
import {
  CLEAR_TOOLTIP_TITLE,
  DATE_ONLY_FORMAT,
  DATE_VIEW_FORMAT,
  DEFAULT_PAGE_NO,
  DEFAULT_TEN_PAGE_SIZE,
  MAX_INT_VALUE,
} from "utils/constants/constant";
import { DEFAULT_SLP_REQUESTS_FILTER } from "utils/constants/slp";
import { AppRoutings } from "utils/enums/app-routings";
import { ContactDateNumber, SLPParticipation } from "utils/enums/slp";
import { SLPFormStep } from "utils/enums/slp-form";
import { Order, OrderByOptions } from "utils/enums/sorting";
import {
  allowSearch,
  checkEndDateLessThanStart,
  getPagePayloadValues,
  onTextFieldKeyPress,
  printPDFHelper,
  showLoader,
  toggleFilter,
} from "utils/helper";
import {
  getSLPParticipationClass,
  getSLPParticipationText,
  getSLPStatusClass,
  getSLPStatusText,
} from "utils/helper/slp";
import {
  IEnhancedTablePropsForSLPRequests,
  ISLPDashboardListMeta,
  ISLPRequest,
  ISLPRequestKeys,
  ISLPRequestsFilter,
  ISLPRequestsPayloadValues,
  IUpdateSLPContactNoteValue,
  IUpdateSLPParticipationValue,
} from "utils/interfaces/slp";
import GenericContactDate from "components/GenericContactDate";
import DeferSLPModal from "components/DeferSLPModal";
import { DeferSLPSelected } from "utils/interfaces/student-profile-details";
import SLPRequestsFilter from "../SLPRequestsFilter";

// ------ CONTACT PROGRESS RELATED CODE -------
// const renderContactProgress = (
//   progress: ContactProgress,
//   onClick?: () => void
// ) => {
//   let icon = editYellowIcon;
//   const className = getContactProgressClass(progress);

//   switch (progress) {
//     case ContactProgress.NotStarted:
//       icon = editYellowIcon;
//       break;
//     case ContactProgress.Assigned:
//       icon = editGreenIcon;
//       break;
//     case ContactProgress.InProgress:
//       icon = editBlueIcon;
//       break;
//     default:
//       icon = editYellowIcon; // fallback
//   }

//   return (
//     <Button
//       className={`btn-progress ${className}`}
//       variant="outlined"
//       onClick={onClick}
//     >
//       <img src={icon} alt="Icon" />
//       <Typography variant="body2" className="w-auto">
//         {getContactProgressText(progress)}
//       </Typography>
//     </Button>
//   );
// };

const EnhancedTableHead = (props: IEnhancedTablePropsForSLPRequests) => {
  const { order, orderBy, onRequestSort, fieldName, keyName, sxStyle } = props;
  const createSortHandler =
    (newOrderBy: keyof ISLPRequestKeys) =>
    (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, newOrderBy);
    };

  return (
    <TableCell
      key={keyName}
      align="left"
      onClick={createSortHandler(keyName)}
      sortDirection={orderBy === keyName ? order : false}
      sx={sxStyle}
      className="term-sorting"
    >
      {fieldName}
      <Box component="span" className="sorting-icon" />
    </TableCell>
  );
};

export type SLPRequestProps = {
  slpRequestsRequest: (payload: SLPRequestsPayload) => {};
  slpRequestsPDFRequest: (payload: SLPRequestsPDFPayload) => {};
  plaUserListRequest: (payload: PLAUserListPayload) => {};
  // updateSLPContactProgressRequest: (
  //   payload: UpdateSLPContactProgressPayload
  // ) => {};
  updateSLPParticipationRequest: (payload: UpdateSLPParticipationPayload) => {};
  updateSLPContactNoteRequest: (payload: UpdateSLPContactNotePayload) => {};
  allocatePLARequest: (payload: AllocatePLAPayload) => void;
  updateContactDateRequest: (payload: IUpdateContactDateRequestPayload) => void;
  isSPLAUser: boolean;
  userId: number;
  deferSLPRequest: (payload: DeferSLPPayload) => void;
};

const SLPRequests: React.FC<SLPRequestProps> = (props) => {
  const {
    plaUserListRequest,
    // updateSLPContactProgressRequest,
    updateSLPParticipationRequest,
    updateSLPContactNoteRequest,
    isSPLAUser,
    allocatePLARequest,
    updateContactDateRequest,
    userId,
    deferSLPRequest,
  } = props;

  const history = useHistory();

  const [slpRequests, setSLPRequests] = useState<Array<ISLPRequest>>([]);
  const [slpRequestsMeta, setSLPRequestsMeta] =
    useState<ISLPDashboardListMeta>();
  const [page, setPage] = useState<string>(DEFAULT_TEN_PAGE_SIZE);
  const [pageNo, setPageNo] = useState<number>(DEFAULT_PAGE_NO);
  const [searchText, setSearchText] = useState<string>("");
  const [order, setOrder] = useState<Order>(OrderByOptions.Desc);
  const [orderBy, setOrderBy] = useState<keyof ISLPRequestKeys>("dueDate");
  const [filterBox, setFilterBox] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<ISLPRequestsFilter>(
    DEFAULT_SLP_REQUESTS_FILTER
  );
  const [appliedFilter, setAppliedFilter] = useState<boolean>(false);
  const [exportMenu, setExportMenu] = useState<null | HTMLElement>(null);

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const [contactProgressModalDetail, setContactProgressModalDetail] =
  //   useState<IUpdateSLPContactProgressValue>();
  const [slpParticipationModalDetail, setSLPParticipationModalDetail] =
    useState<IUpdateSLPParticipationValue>();
  const [contactNoteModalDetail, setContactNoteModalDetail] =
    useState<IUpdateSLPContactNoteValue>();
  const [openAllocateModal, setOpenAllocateModal] = useState<boolean>(false);
  const [selectedSLPId, setSelectedSLPId] = useState<number | null>(null);
  const [allocatedToId, setAllocatedToId] = useState<number | null>(null);
  const [dueDate, setDueDate] = useState<string | null>(null);
  const [openDeferSLP, setOpenDeferSLP] = useState<boolean>(false);
  const [deferSLPDetails, setDeferSLPDetails] =
    useState<DeferSLPSelected | null>(null);
  const exportOpen = Boolean(exportMenu);

  const handleChange = (event: SelectChangeEvent) => {
    setPage(event.target.value as string);
    setPageNo(DEFAULT_PAGE_NO);
  };

  const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setExportMenu(event.currentTarget);
  };
  const handleExportClose = () => {
    setExportMenu(null);
  };

  const onPageChange = (e: React.ChangeEvent<unknown>, value: number) => {
    setPageNo(value);
  };

  const slpRequestsSuccessCallback = (data: SLPRequestsSuccessPayload) => {
    setSLPRequests(data.slpRequests);
    setSLPRequestsMeta(data.slpRequestsPagination);
  };

  const getSLPRequests = (
    filterData: ISLPRequestsFilter,
    filtered?: boolean,
    pageNum?: number
  ) => {
    const { slpRequestsRequest } = props;
    if (slpRequestsRequest) {
      showLoader();
      const values: ISLPRequestsPayloadValues = getPagePayloadValues(
        orderBy,
        order,
        pageNo,
        page
      );
      values.search = filtered ? "" : searchText.trim();

      if (filterData.allocatedTo?.length)
        values.allocatedTo = filterData.allocatedTo;
      if (filterData.numberOfCompletedSLP !== null)
        values.numberOfCompletedSLP = filterData.numberOfCompletedSLP;
      if (filterData.from)
        values.from = dayjs(filterData.from).format(DATE_ONLY_FORMAT);
      if (filterData.to)
        values.to = dayjs(filterData.to).format(DATE_ONLY_FORMAT);
      if (filterData.slpParticipation)
        values.slpParticipation = filterData.slpParticipation;

      if (filterData) {
        setFilteredData(filterData);
        setAppliedFilter(true);

        if (pageNum) {
          values.pageNo = pageNum;
          setPageNo(pageNum);
        }
      } else {
        setFilteredData(DEFAULT_SLP_REQUESTS_FILTER);
      }

      const payload = {
        values,
        callback: slpRequestsSuccessCallback,
      };
      slpRequestsRequest(payload);
    }
  };

  const getSLPRequestsModifiedData = (list: Array<ISLPRequest>) => {
    const data = list?.map((slp: ISLPRequest) => {
      return {
        "SLP Number": slp.slpNumber,
        "Student Name": slp.studentName,
        "SLP Status": getSLPStatusText(slp.status),
        "Assign On": slp.allocatedOn
          ? moment(slp.allocatedOn).format(DATE_VIEW_FORMAT)
          : "-",
        "Assign By": slp.allocatedByName ?? "-",
        "Allocated To": slp.allocatedToName ?? "-",
        "Due Date": moment(slp.dueDate).format(DATE_VIEW_FORMAT),
        "SLP Participation": getSLPParticipationText(slp.slpParticipation),
        "Contact Date 1": slp.contactDateOne
          ? moment(slp.contactDateOne).format(DATE_VIEW_FORMAT)
          : "-",
        "Contact Date 2": slp.contactDateTwo
          ? moment(slp.contactDateTwo).format(DATE_VIEW_FORMAT)
          : "-",
        // "Contact Progress": getContactProgressText(slp.contactProgress),
        "Contact Notes": slp.contactNotes ?? "-",
      };
    });

    return data;
  };

  const slpExportRequestsSuccessCallback = (
    data: SLPRequestsSuccessPayload
  ) => {
    if (!data.slpRequests.length) {
      toast.error(NO_RECORD_FOUND);

      return;
    }

    const modifiedData = getSLPRequestsModifiedData(data.slpRequests);
    const csvFileHeaders = [
      "SLP Number",
      "Student Name",
      "SLP Status",
      "Assign On",
      "Assign By",
      "Allocated To",
      "Due Date",
      "SLP Participation",
      "Contact Date 1",
      "Contact Date 2",
      // "Contact Progress",
      "Contact Notes",
    ];

    const options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useTextFile: false,
      useBom: true,
      headers: csvFileHeaders,
      filename: "SLPRequests",
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(modifiedData);
  };

  const getExportSLPRequests = () => {
    const { slpRequestsRequest } = props;
    if (slpRequestsRequest) {
      showLoader();
      const values: ISLPRequestsPayloadValues = getPagePayloadValues(
        orderBy,
        order,
        DEFAULT_PAGE_NO,
        MAX_INT_VALUE
      );
      values.search = searchText.trim();

      if (filteredData.allocatedTo?.length)
        values.allocatedTo = filteredData.allocatedTo;
      if (filteredData.numberOfCompletedSLP)
        values.numberOfCompletedSLP = filteredData.numberOfCompletedSLP;
      if (filteredData.from)
        values.from = dayjs(filteredData.from).format(DATE_ONLY_FORMAT);
      if (filteredData.to)
        values.to = dayjs(filteredData.to).format(DATE_ONLY_FORMAT);
      if (filteredData.slpParticipation)
        values.slpParticipation = filteredData.slpParticipation;

      const payload = {
        values,
        callback: slpExportRequestsSuccessCallback,
      };

      slpRequestsRequest(payload);
      handleExportClose();
    }
  };

  useEffect(() => {
    if (!appliedFilter) getSLPRequests(filteredData, true, DEFAULT_PAGE_NO);
    else getSLPRequests(filteredData);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [page, pageNo, order, orderBy]);

  const handleRequestSort = useCallback(
    (event: React.MouseEvent<unknown>, newOrderBy: keyof ISLPRequestKeys) => {
      const isAsc = orderBy === newOrderBy && order === OrderByOptions.Asc;
      const toggledOrder = isAsc ? OrderByOptions.Desc : OrderByOptions.Asc;
      setOrder(toggledOrder);
      setOrderBy(newOrderBy);
    },
    [order, orderBy]
  );

  const handleStudentSearchKeyDown = (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (allowSearch(e)) {
      if (pageNo === DEFAULT_PAGE_NO) {
        getSLPRequests(filteredData);
      } else setPageNo(DEFAULT_PAGE_NO);
    }
    onTextFieldKeyPress(e, searchText?.length);
  };

  const handleStudentSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
    if (pageNo === DEFAULT_PAGE_NO) {
      getSLPRequests(filteredData, true);
    } else setPageNo(DEFAULT_PAGE_NO);
  };

  const handleFilterApplyClick = (formData: ISLPRequestsFilter) => {
    if (
      formData.from &&
      formData.to &&
      checkEndDateLessThanStart(new Date(formData.from), new Date(formData.to))
    ) {
      toast.error(DUE_DATE_TO_SHOULD_GREATER_MSG);

      return;
    }

    setFilteredData(formData);
    setSearchText("");
    if (pageNo === DEFAULT_PAGE_NO) {
      getSLPRequests(formData, true, DEFAULT_PAGE_NO);
    } else {
      setPageNo(DEFAULT_PAGE_NO);
    }
    setFilterBox(false);
    toggleFilter();
  };

  const slpRequestsPDFSuccessCallback = (
    response: SLPRequestsPDFSuccessPayload
  ) => {
    printPDFHelper(response.slpRequestPDF);
  };

  const getSLPRequestsPDF = () => {
    const { slpRequestsPDFRequest } = props;
    if (slpRequestsPDFRequest) {
      showLoader();
      const values: ISLPRequestsPayloadValues = getPagePayloadValues(
        orderBy,
        order,
        DEFAULT_PAGE_NO,
        MAX_INT_VALUE
      );
      values.search = searchText.trim();

      if (filteredData.allocatedTo?.length)
        values.allocatedTo = filteredData.allocatedTo;
      if (filteredData.numberOfCompletedSLP)
        values.numberOfCompletedSLP = filteredData.numberOfCompletedSLP;
      if (filteredData.from)
        values.from = dayjs(filteredData.from).format(DATE_ONLY_FORMAT);
      if (filteredData.to)
        values.to = dayjs(filteredData.to).format(DATE_ONLY_FORMAT);
      if (filteredData.slpParticipation)
        values.slpParticipation = filteredData.slpParticipation;

      const payload = {
        values,
        callback: slpRequestsPDFSuccessCallback,
      };

      slpRequestsPDFRequest(payload);
      handleExportClose();
    }
  };

  const isSLPParticipationNoFurtherSLPRequired = useMemo(() => {
    return filteredData.slpParticipation.includes(
      SLPParticipation.NoFurtherSLPRequired
    );
  }, [filteredData.slpParticipation]);

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const handleContactProgressClick = (slp: ISLPRequest) => {
  //   setContactProgressModalDetail({
  //     id: slp.id,
  //     contactProgress: slp.contactProgress,
  //   });
  // };

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const handleContactProgressModalClose = () => {
  //   setContactProgressModalDetail(undefined);
  // };

  // ------ CONTACT PROGRESS RELATED CODE -------
  // const updateContactProgressCallback = () => {
  //   toast.success(CONTACT_PROGRESS_UPDATE_MSG);
  //   getSLPRequests(filteredData);
  //   handleContactProgressModalClose();
  // };

  const handleParticipationClick = (
    id: number,
    participation: SLPParticipation
  ) => {
    setSLPParticipationModalDetail({
      studentId: id,
      slpParticipation: participation,
    });
  };

  const handleParticipationModalClose = () => {
    setSLPParticipationModalDetail(undefined);
  };

  const updateParticipationCallback = () => {
    toast.success(SLP_PARTICIPATION_UPDATE_MSG);
    getSLPRequests(filteredData);
    handleParticipationModalClose();
  };

  const handleContactNoteClick = (slp: ISLPRequest) => {
    setContactNoteModalDetail({
      id: slp.id,
      note: slp.contactNotes ?? "",
    });
  };

  const handleContactNoteModalClose = () => {
    setContactNoteModalDetail(undefined);
  };

  const updateContactNoteCallback = () => {
    toast.success(CONTACT_NOTE_ADD_SUCCESS_MESSAGE);
    getSLPRequests(filteredData);
    handleContactNoteModalClose();
  };

  const handleAllocateToPLA = (
    slpId: number,
    plaId: number | null,
    date: string
  ) => {
    setSelectedSLPId(slpId);
    setDueDate(date);
    setAllocatedToId(plaId);
    setOpenAllocateModal(true);
  };

  useEffect(() => {
    if (!openAllocateModal) {
      setSelectedSLPId(null);
      setAllocatedToId(null);
      setDueDate(null);
    }
  }, [openAllocateModal]);

  const updateSLPRequestsCallback = () => {
    getSLPRequests(filteredData);
  };

  const handleDeferSLP = (slpId: number, selectedDate: string) => {
    setDeferSLPDetails({ slpId, dueDate: selectedDate });
    setOpenDeferSLP(true);
  };

  const deferSLPCallback = () => {
    getSLPRequests(filteredData);
    setDeferSLPDetails(null);
  };

  return (
    <>
      <Grid item xs={12}>
        <Card>
          <Box className="table-card-header">
            <Typography variant="h3">
              Search Student Profiles & SLP Request
            </Typography>
            <Box>
              <TextField
                id="search-box"
                variant="outlined"
                className="search-input"
                placeholder="Search Student"
                value={searchText}
                onChange={handleStudentSearch}
                onKeyDown={handleStudentSearchKeyDown}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      sx={{ position: "absolute", right: "0" }}
                      position="end"
                    >
                      {searchText && (
                        <Tooltip
                          TransitionComponent={Fade}
                          TransitionProps={{ timeout: 600 }}
                          title={CLEAR_TOOLTIP_TITLE}
                          arrow
                        >
                          <IconButton edge="end" onClick={handleClearSearch}>
                            <img src={closeIcon} alt="close" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                id="export-btn"
                aria-controls={exportOpen ? "export-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={exportOpen ? "true" : undefined}
                onClick={handleExportClick}
                disableElevation
                variant="outlined"
                className="btn-export"
                disabled={!slpRequestsMeta?.totalCount}
              >
                Export
              </Button>
              <Menu
                id="export-menu"
                anchorEl={exportMenu}
                open={exportOpen}
                onClose={handleExportClose}
                MenuListProps={{
                  "aria-labelledby": "export-button",
                }}
                className="export-menu"
              >
                <MenuItem title="Excel" onClick={getExportSLPRequests}>
                  <Button>Excel</Button>
                </MenuItem>
                <MenuItem title="PDF" onClick={getSLPRequestsPDF}>
                  <Button>PDF</Button>
                </MenuItem>
              </Menu>

              <Button
                variant="outlined"
                className="btn-filter"
                onClick={() => {
                  setFilterBox(true);
                  toggleFilter();
                }}
              >
                <img src={filterPrimaryIcon} alt="filter" className="default" />
                <img src={filterLightIcon} alt="filter" className="active" />
                <span>Filter</span>
              </Button>
            </Box>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      maxWidth: "84px",
                      width: "84px",
                      minWidth: "84px",
                    }}
                  >
                    SLP Number
                  </TableCell>
                  <EnhancedTableHead
                    onRequestSort={(e) => handleRequestSort(e, "studentName")}
                    order={order}
                    orderBy={orderBy}
                    fieldName="Student Name"
                    keyName="studentName"
                    sxStyle={{ width: "154px", minWidth: "154px" }}
                  />
                  <TableCell align="center" sx={{ width: "120px" }}>
                    SLP Status
                  </TableCell>
                  <EnhancedTableHead
                    onRequestSort={(e) => handleRequestSort(e, "allocatedOn")}
                    order={order}
                    orderBy={orderBy}
                    fieldName="Assigned On"
                    keyName="allocatedOn"
                    sxStyle={{ width: "120px", minWidth: "120px" }}
                  />
                  <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                    Assigned By
                  </TableCell>
                  <TableCell sx={{ width: "120px", minWidth: "120px" }}>
                    Allocated To
                  </TableCell>
                  <EnhancedTableHead
                    onRequestSort={(e) => handleRequestSort(e, "dueDate")}
                    order={order}
                    orderBy={orderBy}
                    fieldName="Due Date"
                    keyName="dueDate"
                    sxStyle={{ width: "120px", minWidth: "120px" }}
                  />
                  <TableCell
                    sx={{
                      width: isSLPParticipationNoFurtherSLPRequired
                        ? "240px"
                        : "120px",
                      minWidth: isSLPParticipationNoFurtherSLPRequired
                        ? "240px"
                        : "120px",
                    }}
                    align="center"
                  >
                    SLP Participation
                  </TableCell>
                  <EnhancedTableHead
                    onRequestSort={(e) =>
                      handleRequestSort(e, "contactDateOne")
                    }
                    order={order}
                    orderBy={orderBy}
                    fieldName="Contact Date 1"
                    keyName="contactDateOne"
                    sxStyle={{ width: "160px", minWidth: "160px" }}
                  />
                  <EnhancedTableHead
                    onRequestSort={(e) =>
                      handleRequestSort(e, "contactDateTwo")
                    }
                    order={order}
                    orderBy={orderBy}
                    fieldName="Contact Date 2"
                    keyName="contactDateTwo"
                    sxStyle={{ width: "160px", minWidth: "160px" }}
                  />
                  {/* ------ CONTACT PROGRESS RELATED CODE ------- */}
                  {/* <TableCell
                    sx={{ width: "150px", minWidth: "150px" }}
                    align="center"
                  >
                    Contact Progress
                  </TableCell> */}
                  <TableCell
                    align="center"
                    sx={{ width: "100px", minWidth: "100px" }}
                  >
                    Contact Notes
                  </TableCell>
                  <TableCell align="center" sx={{ width: "121px" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {slpRequests.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row" align="center">
                      {row.slpNumber}
                    </TableCell>
                    <TableCell className="break-word">
                      {row.studentName}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={`${getSLPStatusClass(row.status)} status`}
                    >
                      <div>{getSLPStatusText(row.status)}</div>
                    </TableCell>
                    <TableCell>
                      {row.allocatedOn
                        ? moment(row.allocatedOn).format(DATE_VIEW_FORMAT)
                        : "-"}
                    </TableCell>
                    <TableCell className="break-word">
                      {row.allocatedByName ?? "-"}
                    </TableCell>
                    <TableCell className="break-word">
                      {row.allocatedToName ?? "-"}
                    </TableCell>
                    <TableCell>
                      {moment(row.dueDate).format(DATE_VIEW_FORMAT)}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        className={`btn-progress ${getSLPParticipationClass(
                          row.slpParticipation
                        )}`}
                        variant="outlined"
                        onClick={() =>
                          handleParticipationClick(
                            row.studentId,
                            row.slpParticipation
                          )
                        }
                      >
                        <img
                          src={
                            row.slpParticipation === SLPParticipation.Active
                              ? editPurpleIcon
                              : editGreyIcon
                          }
                          alt="Icon"
                        />
                        <Typography variant="body2">
                          {getSLPParticipationText(row.slpParticipation)}
                        </Typography>
                      </Button>
                    </TableCell>
                    <TableCell>
                      <GenericContactDate
                        slpId={row.id}
                        contactDateNumber={ContactDateNumber.ContactDateOne}
                        contactDate={row.contactDateOne}
                        updateContactDateRequest={updateContactDateRequest}
                        updateSLPRequestsCallback={updateSLPRequestsCallback}
                      />
                    </TableCell>
                    <TableCell>
                      <GenericContactDate
                        slpId={row.id}
                        contactDateNumber={ContactDateNumber.ContactDateTwo}
                        contactDate={row.contactDateTwo}
                        updateContactDateRequest={updateContactDateRequest}
                        updateSLPRequestsCallback={updateSLPRequestsCallback}
                      />
                    </TableCell>
                    {/* // ------ CONTACT PROGRESS RELATED CODE ------- */}
                    {/* <TableCell align="center">
                      {renderContactProgress(row.contactProgress, () =>
                        handleContactProgressClick(row)
                      )}
                    </TableCell> */}
                    <TableCell align="center">
                      <div className="table-actions">
                        <IconButton onClick={() => handleContactNoteClick(row)}>
                          <img src={noteIcon} alt="Icon" />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className="table-actions">
                        {isSPLAUser && (
                          <Tooltip title="Allocate" arrow>
                            <IconButton
                              onClick={() => {
                                handleAllocateToPLA(
                                  row.id,
                                  row.allocatedTo,
                                  row.dueDate.toString()
                                );
                              }}
                            >
                              <img src={personEditIcon} alt="Edit" />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Defer SLP" arrow>
                          <IconButton
                            onClick={() =>
                              handleDeferSLP(row.id, row.dueDate.toString())
                            }
                          >
                            <img src={calendarEditIcon} alt="Edit" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Student Profile" arrow>
                          <IconButton
                            onClick={() =>
                              history.push({
                                pathname: AppRoutings.StudentProfileDetails,
                                state: {
                                  studentId: Number(row.studentId),
                                  slpId: Number(row.id),
                                },
                              })
                            }
                          >
                            <img
                              src={courseListSecondaryIcon}
                              alt="View"
                              style={{ height: "17px", width: "17px" }}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Start SLP" arrow>
                          <IconButton
                            onClick={() =>
                              history.push({
                                pathname: AppRoutings.SLPForm,
                                state: {
                                  studentId: Number(row.studentId),
                                  slpId: Number(row.id),
                                  partNumber: SLPFormStep.HOPES_GOALS_AMBITIONS,
                                  userId,
                                },
                              })
                            }
                          >
                            <img src={listCheckIcon} alt="Edit" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {slpRequestsMeta && !!slpRequests.length ? (
            <CustomPagination
              handleChange={handleChange}
              page={page}
              pageNo={pageNo}
              onPageChange={onPageChange}
              listMeta={slpRequestsMeta}
            />
          ) : (
            <NoRecords />
          )}
        </Card>
      </Grid>
      {filterBox && (
        <SLPRequestsFilter
          filterBox={filterBox}
          setFilterBox={setFilterBox}
          handleApplyClick={handleFilterApplyClick}
          filteredData={filteredData}
          pageNo={pageNo}
          setPageNo={setPageNo}
          setFilteredData={setFilteredData}
          getSLPRequests={getSLPRequests}
          setAppliedFilter={setAppliedFilter}
          plaUserListRequest={plaUserListRequest}
        />
      )}

      {/* // ------ CONTACT PROGRESS RELATED CODE ------- */}
      {/* {!!contactProgressModalDetail && (
        <SLPContactProgressModal
          onClose={handleContactProgressModalClose}
          contactProgressDetail={contactProgressModalDetail}
          updateSLPContactProgressRequest={updateSLPContactProgressRequest}
          onSaveCallback={updateContactProgressCallback}
        />
      )} */}
      {!!slpParticipationModalDetail && (
        <SLPParticipationModal
          onClose={handleParticipationModalClose}
          slpParticipationDetail={slpParticipationModalDetail}
          updateSLPParticipationRequest={updateSLPParticipationRequest}
          onSaveCallback={updateParticipationCallback}
        />
      )}
      {!!contactNoteModalDetail && (
        <SLPContactNoteModal
          onClose={handleContactNoteModalClose}
          contactNoteDetail={contactNoteModalDetail}
          updateSLPContactNoteRequest={updateSLPContactNoteRequest}
          onSaveCallback={updateContactNoteCallback}
        />
      )}
      {!!selectedSLPId && openAllocateModal && (
        <AllocateSLPModal
          slpId={selectedSLPId}
          allocatedToId={allocatedToId}
          dueDate={dueDate}
          openAllocateModal={openAllocateModal}
          setOpenAllocateModal={setOpenAllocateModal}
          updateAllocatePLACallback={updateSLPRequestsCallback}
          allocatePLARequest={allocatePLARequest}
          plaUserListRequest={plaUserListRequest}
        />
      )}
      {deferSLPDetails?.dueDate && (
        <DeferSLPModal
          openDeferSLP={openDeferSLP}
          dueDate={deferSLPDetails?.dueDate}
          slpId={deferSLPDetails?.slpId}
          deferSLPRequest={deferSLPRequest}
          setOpenDeferSLP={setOpenDeferSLP}
          deferSLPCallback={deferSLPCallback}
        />
      )}
    </>
  );
};
export default SLPRequests;
